import { AnimatePresence, motion } from 'framer-motion'

type FadePresenceProps = {
    renderKey?: string | number | boolean
    initial?: boolean
    fullWidth?: boolean
    style?: React.CSSProperties
}

export const FadePresence: React.FC<FadePresenceProps> = ({
    renderKey,
    initial = false,
    fullWidth = false,
    style,
    children,
}) => {
    return (
        <AnimatePresence exitBeforeEnter initial={initial}>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                key={`${renderKey}`}
                style={{ ...style, ...(fullWidth ? { width: '100%' } : {}) }}
            >
                {children}
            </motion.div>
        </AnimatePresence>
    )
}
